<template>
    <div>
        <Paper :header="$t('components.smart.featuredResource.header')" tall>
            <div style="overflow: hidden;" class="rounded-bottom">
                <LinkCarouselItem :title="title" :img="img" :link="link" />
            </div>
        </Paper>
    </div>
</template>

<script>
import LinkCarouselItem from '~/components/miscellaneous/Link.CarouselItem';
import i18n from '~/i18n';

export default {
    name: 'FeaturedResource',
    components: { LinkCarouselItem },
    data() {
        return {
            title: i18n.t('components.smart.featuredResource.cta'),
            img:
                'https://content.gethighered.global/masterclasspromotion/2020_jan_linkedin.png',
            link:
                'https://zoom.us/webinar/register/6015752918434/WN_a3GQwv_sRU62KoUrH0OlqA',
        };
    },
};
</script>

<style lang="css" scoped></style>
